import {postForm, postfile, post} from './http'
const baseUrl = '/api'
// 上传
export const getUploadParam = data => post(`${baseUrl}/meas/admin/system/getFileUploadFormInfoBySingle`, data)
export const qiniuFormUpload = v => postfile(v.url, v.data)

// 获取老师下拉列表
export const getCourseTeachListBySelect = data => post(`${baseUrl}/meas/admin/resource/system/getCourseTeachListBySelect`, data)